// extracted by mini-css-extract-plugin
export default {"container":"sQ-z","topReviewHeading":"tQ-z","criticalReview":"uQ-z","favorableReview":"vQ-z","vsSeparator":"wQ-z"};